import CRMApi from '../api/CRMApi';
import CSRApi from '../../../../YourDedicatedTeams/src/app/api/payloadApi';
import ChatScriptApi from '../../../../ContactChat/src/app/api/payloadApi';

import { loadCrmKnowlegdeArticlesSuccess } from './crmActions';
import { loadChatScriptSuccess } from '../../../../ContactChat/src/app/actions/chatScriptActions';
import { loadCustomerServiceInfoSuccess, loadingCustomerServiceInfo } from '../../../../YourDedicatedTeams/src/app/actions/customerServiceInfoActions';

export function loadCrmArticles(searchString) {
    return function (dispatch) {

        return CRMApi.getCrmArticles(searchString).then(payload => {
            dispatch(loadCrmKnowlegdeArticlesSuccess(payload));
        }).catch(error => {
            throw error;
        });
    };
}

export function loadCSRInfo() {
    return function (dispatch) {
        dispatch(loadingCustomerServiceInfo());
        return CSRApi.getPayload().then(payload => {
            dispatch(loadCustomerServiceInfoSuccess(payload));
        }).catch(error => {
            throw error;
        });
    };
}

export function loadChatInfo() {
    return function (dispatch) {
        return ChatScriptApi.getPayload().then(payload => {
            dispatch(loadChatScriptSuccess(payload));
        }).catch(error => {
            throw error;
        });
    };
}
